import { render } from "./KeyAsis.vue?vue&type=template&id=7f12787c&scoped=true"
import script from "./KeyAsis.vue?vue&type=script&lang=js"
export * from "./KeyAsis.vue?vue&type=script&lang=js"

import "./KeyAsis.vue?vue&type=style&index=0&id=7f12787c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f12787c"]])

export default __exports__